module.exports = __webpack_public_path__ + "media/images/icons/filled/highlight-243584c50e3670511e1251b6cf22ab9a.svg";